import React, { useContext } from 'react';
import styled from 'styled-components';
import { ContentfulContext } from '../context/Contentful';
import { useBrandDetails } from 'dw-au-react-components';

const StyledPlpSeoBottom = styled.div`
	div:empty,
	p:empty,
	br {
		display: none;
	}

	div,
	ul,
	ol,
	p {
		margin-bottom: 16px !important;
	}

	ul,
	ol {
		text-align: left !important;
		padding-left: 40px;
	}

	ul {
		list-style: disc !important;
	}
`;

const PlpSeoBottom = () => {
	const { tag } = useBrandDetails();
	const { plpSeoCopy } = useContext(ContentfulContext);

	return plpSeoCopy?.longCopy ? (
		<StyledPlpSeoBottom>
			<div
				className='mt-60 pl-10 pr-10'
				dangerouslySetInnerHTML={{
					__html: plpSeoCopy?.longCopy
						.replaceAll(
							'<h6>',
							`<div class="subtitle mt-30 mb-16 ${
								tag === 'vir' ? 'lower' : ''
							}">`
						)
						.replaceAll('</h6>', '</div>')
				}}
			></div>
		</StyledPlpSeoBottom>
	) : null;
};

export default PlpSeoBottom;
